// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import Head from 'react-helmet';
import styled from 'styled-components';

import Container from 'app/shared/core/Container';
import Linker from 'app/shared/modules/Linker';
import pathsManifest from 'app/shared/utils/pathsManifest';
import ListItem from 'app/shared/modules/ListItem';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import './style.scss';
import Title from 'app/shared/modules/Title';
import Text from 'app/shared/core/Text';

const StyledBoldSpan = styled.span`
  font-weight: 700;
`;
class AboutUsPage extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="HeaderFooterTemplate">
        <Head
          title="About us | HotPads"
          meta={[
            {
              name: 'description',
              content:
                'Learn about HotPads, the largest and most trusted apartment and home rental site with verified listings and real-time property updates.',
            },
            { property: 'og:title', content: 'About us | HotPads' },
            {
              property: 'og:description',
              content:
                'Learn about HotPads, the largest and most trusted apartment and home rental site with verified listings and real-time property updates.',
            },
            { property: 'og:url', content: 'https://hotpads.com/about-us' },
            { property: 'og:type', content: 'website' },
            { property: 'og:site_name', content: 'HotPads' },
            {
              property: 'og:image',
              content: 'http://filenet.hotpads.com/images/logos/logo_square.png',
            },
          ]}
        />
        <Container>
          <div className="AboutUsPage">
            <Section>
              <Title size="xl" htmlTag="h1">
                About Us
              </Title>
            </Section>
            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  HotPads helps you handle the hottest urban housing markets.
                </Title>
              </Row>
              <Text size="md">
                <p>
                  When did apartment hunting get so Hunger Games? When did we start camping out overnight just for
                  in-unit laundry? When did paying a deposit start feeling like paying a ransom?
                </p>
                <p>
                  Yeah, we’ve been there. We get it. We know that searching for your next place can be a mix of awesome
                  and awful. Our mission? To tip the scales toward awesome.
                </p>
              </Text>
            </div>
            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  HotPads is the rental search platform designed with the urban renter in mind.
                </Title>
              </Row>
              <Text size="md">
                <p>
                  We know that searching in the city is different—urban real estate is always hot, and you have to be
                  ready to move fast when you find your apartment soul mate. That’s why we’re always creating and
                  improving on the most essential features:
                </p>
                <div>
                  <ul>
                    <ListItem>
                      <StyledBoldSpan>The most trusted and comprehensive listings,</StyledBoldSpan> thanks to verified
                      landlord contact information, landlord ratings, realtime updates, user reviews—when it comes to
                      fraud, we got your back.
                    </ListItem>
                    <ListItem>
                      <StyledBoldSpan>Notifications</StyledBoldSpan> to your phone with new listings that match your
                      customized search preferences—like, maybe you must have a dishwasher, maybe you’d rather have
                      heat.
                    </ListItem>
                    <ListItem>
                      <StyledBoldSpan>Map-based search</StyledBoldSpan> for visibility into neighborhood amenities, from
                      dog parks to bottle shops to bike shares.
                    </ListItem>
                    <ListItem>
                      <StyledBoldSpan>Commute time calculator,</StyledBoldSpan> so you can estimate the number of
                      podcasts you’ll need each morning.
                    </ListItem>
                    <ListItem>
                      <StyledBoldSpan>All-in-one tools and resources—</StyledBoldSpan>
                      like having your own personal real estate agent in your hoodie pocket.
                    </ListItem>
                  </ul>
                </div>
              </Text>
            </div>

            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  Created by your friends who’ve been there.
                </Title>
              </Row>
              <Text size="md">
                <p>
                  HotPads was created in Washington, DC, in 2005, by three apartment-seeking college friends. After too
                  many misleading classified ads and nicotine-scented payphones, they knew they could do better. So they
                  created HotPads, the first-ever map-based, renter-first, odor-free search platform. In 2011, HotPads
                  moved to San Francisco, and in 2012, HotPads joined the Zillow family. Today, HotPads continues to
                  build game-changing features into its rental search website and apps for iPhone, Android, and iPad.
                </p>
              </Text>
            </div>

            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  List Your Place on HotPads
                </Title>
              </Row>
              <Text size="md">
                <p>
                  If you want to get your listing on HotPads, the best way to do so is through our{' '}
                  <Linker to={pathsManifest.PostAListingPage}> own posting path</Linker>.
                </p>
              </Text>
            </div>

            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  We're Always Hiring
                </Title>
              </Row>
              <Text size="md">
                <p>
                  We're always looking for smart creative people to join our team.{' '}
                  <Linker to="https://www.zillow.com/jobs/openings/?l=San%20Francisco">
                    {' '}
                    Check out our job listings here.
                  </Linker>
                </p>
              </Text>
            </div>

            <div className="AboutUsSection">
              <Row>
                <Title size="md" htmlTag="h2">
                  Need To Get In Touch?
                </Title>
              </Row>
              <Text size="md">
                <p>
                  Sometimes people need to get in touch. We get it. Check out our{' '}
                  <Linker to={pathsManifest.help}>FAQ</Linker> for quick answers to your questions, or shoot us an email
                  at <Linker to="mailto:info@hotpads.com"> info@hotpads.com</Linker>. Press inquiries can be sent to{' '}
                  <Linker to="mailto:press@hotpads.com"> press@hotpads.com</Linker>.
                </p>
              </Text>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default connect()(AboutUsPage);
